import React from 'react'
import {AboutContainer, AboutH1, AboutH3, AboutH4, ImgContainer, Wrapper} from './AboutElements';
import ImgPic from '../../img/profp compressed.jpg';
import 'render-smooth-image-react/build/style.css';
import Tilt from 'react-parallax-tilt';
function About() {
    return (
        <div>
            <AboutContainer id="about">
            
                <AboutH1>About Me</AboutH1>
                
                <Wrapper>
                
                    <ImgContainer>
                        <div class="smooth-image-wrapper">
                            <img src={ImgPic} width={200} class = "smooth-image-visible" height={300} alt="pic"/>
                        </div>
                    </ImgContainer>
                    <Tilt tiltMaxAngleX={10} tiltMaxAngleY={20}>
                    <AboutH4>
                        {"<"}Childhood{"/>"}
                    </AboutH4>
                    <AboutH3 >
                    Hi, I am Kovács Bálint Hunor. I am a student at Sapientia college, 
                    and I am from Sepsiszentgyörgy, Romania. Since I was a kid, 
                    I always searched for opportunities,  
                    I loved to create things that can be useful to others.
                    </AboutH3>
                    </Tilt>
                    <Tilt tiltMaxAngleX={15} tiltMaxAngleY={20}>
                    <AboutH4>
                    {"<"}History{"/>"}
                    </AboutH4>
                    <AboutH3>
                    I started coding in high school, 
                    I immediately fall in love with it. 
                    Since then I have made a lot of websites, web apps, 
                    and mobile apps that made me realize that this is what I want to work for. 
                    </AboutH3>
                    </Tilt>
                    <Tilt tiltMaxAngleX={10} tiltMaxAngleY={20}>
                    <AboutH4>
                    {"<"}Hobbies{"/>"}
                    </AboutH4>
                    <AboutH3>
                    I also fell in love with writing music, poems and learned new ways to express myself,
                    but these hobbies never got in the way of coding.
                    Making a website nowadays is pretty easy, but making a good one, 
                    that needs a lot of knowledge, and I think I have the demanded experience.
                    </AboutH3>
                    </Tilt>
                </Wrapper>
                
            </AboutContainer>
        </div>
    )
}

export default About
